import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d304e66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, null, -1))

import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useInfo } from '@/store';
import { isPC } from '@/hooks/useCheck';

export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavbar',
  setup(__props) {

_useCssVars(_ctx => ({
  "312305e2": (_unref(logo).pc),
  "5e7411be": (_unref(logo).mobile)
}))

const { navigationBar } = storeToRefs(useInfo());
const { getImg } = useInfo();
const query = ref({});
setTimeout(() => {
  const search = new URLSearchParams(window.location.search);
  query.value = {
    lang: search.get('lang'),
    region: search.get('region'),
  };
}, 1000);
const logo = computed(() => ({
  pc: `url(${getImg('home_pc_ff_logo')})`,
  mobile: `url(${getImg('home_mobile_ff_logo')})`,
}));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(navigationBar).menus.length > 0)
    ? (_openBlock(), _createElementBlock("header", {
        key: 0,
        class: _normalizeClass({ pc: _unref(isPC) })
      }, [
        _createElementVNode("nav", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigationBar).menus, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.name
              }, [
                _createVNode(_component_router_link, {
                  to: {
              path: item.link === '/' ? item.link : item.link + '/',
              query: query.value,
            }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})